import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import { uiActions } from '../slices/uiSlice';
import type { RootState } from '../store';

import { groupsService } from './_deps';

export const fetchGroups = createAsyncThunk<void, void, { state: RootState }>(
  'groups/fetch',
  async (_, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    try {
      const res = await groupsService.listGroups();
      dispatch(entitiesActions.setGroups(res.items));
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Не удалось загрузить группы';
      throw error;
    }
  },
);
